module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ibox"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "ibox-results-filters-collapse-box collapse in"
  }, [_c('div', {
    staticClass: "ibox-results-filters"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-lg-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Keywords")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Search here.."
    },
    on: {
      "input": _vm.updateKeywords
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-lg-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Order")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Reference"
    },
    on: {
      "input": _vm.updateOrder
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-lg-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Commodity")]), _vm._v(" "), _c('selectize', {
    attrs: {
      "options": _vm.commodityOptionsWithAll,
      "name": "commodity"
    },
    model: {
      value: (_vm.commodity),
      callback: function($$v) {
        _vm.commodity = $$v
      },
      expression: "commodity"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.$user.isAdminOrCoordinator) ? _c('div', {
    staticClass: "col-sm-6 col-lg-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("User")]), _vm._v(" "), _c('selectize', {
    attrs: {
      "options": _vm.initialUserOptions,
      "name": "user",
      "fetch-results": _vm.fetchUserResults
    },
    model: {
      value: (_vm.user_id),
      callback: function($$v) {
        _vm.user_id = $$v
      },
      expression: "user_id"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-lg-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Status")]), _vm._v(" "), _c('selectize', {
    attrs: {
      "options": _vm.statusOptions,
      "name": "status"
    },
    model: {
      value: (_vm.status),
      callback: function($$v) {
        _vm.status = $$v
      },
      expression: "status"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-lg-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Date Range")]), _vm._v(" "), _c('date-range', {
    attrs: {
      "name": "date_range"
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "ibox-content"
  }, [_c('ul', {
    staticClass: "list-detail list-detail-job public-options"
  }, _vm._l((_vm.jobsDecorated), function(job) {
    return _c('job-item', {
      key: job.id,
      attrs: {
        "job": job
      }
    })
  })), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.haveNoJobs),
      expression: "haveNoJobs"
    }],
    staticClass: "text-center text-muted"
  }, [_c('strong', [_vm._v("There are no jobs.")])])]), _vm._v(" "), _c('lazy-loading', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.haveJobs),
      expression: "haveJobs"
    }],
    ref: "lazyLoading",
    attrs: {
      "reached-bottom": _vm.getJobsForNextPage,
      "filters": _vm.filters
    }
  }, [_c('strong', {
    staticClass: "text-muted",
    slot: "finished"
  }, [_vm._v("There are no more jobs.")])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "ibox-results-collapse visible-xs",
    attrs: {
      "role": "button",
      "data-toggle": "collapse",
      "href": ".ibox-results-filters-collapse-box",
      "aria-expanded": "false",
      "aria-controls": "ibox-results-filters-collapse-box"
    }
  }, [_vm._v("\n    Show Filters "), _c('i', {
    staticClass: "fa fa-bars"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-3181615d"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/jobs/Jobs.vue
// module id = 966
// module chunks = 0